import React, { useContext } from "react";
import { Box, Grid, Typography } from "@mui/material";
import IconText from "../../common/IconText";
import moment from "moment";
import { CheckOutlined } from "@mui/icons-material/";
import currency from "currency.js";
import CloseIcon from "@mui/icons-material/Close";
import { UserContext } from "../../context/UserContext";
import { getDeliveryProviderDisplayName } from "../../common/util";

export default function QuoteFulfillment(props) {
  const { user } = useContext(UserContext);
  const { quote } = props;
  const deliveryType = quote.fulfillment.option.delivery.type;
  const deliveryOption = quote.fulfillment.option.delivery;
  const deliveryConfig = user?.config?.fulfillment?.delivery;

  const getThirdPartyDeliveryText = () => {
    const providerName = getDeliveryProviderDisplayName(deliveryType, deliveryConfig);
    return `${providerName} Delivery`;
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <Box py={0.5} textAlign={"center"}>
            <Typography variant="overline" color="textSecondary">
              {moment(quote.fulfillment.date).format("ddd")}
            </Typography>
            <Typography variant="h4">
              {moment(quote.fulfillment.date).format("MMM D, YYYY")}
            </Typography>
            <Typography variant="body2">
              {quote.fulfillment.time ? ` [${quote.fulfillment.time}]` : ""}
            </Typography>
          </Box>
        </Grid>
        <Grid item sm={6} xs={12}>
          <Box py={0.5}>
            <IconText icon={CheckOutlined} text={"Store Pickup"} variant="body1" />
          </Box>
          {deliveryType === "in-house" && deliveryOption.location && (
            <IconText
              icon={CheckOutlined}
              text={`In-house Delivery: ${currency(deliveryOption.total).format()} to Zip Code (${
                deliveryOption.location.zip
              })`}
              variant="body1"
            />
          )}
          {deliveryType !== "in-house" && deliveryType !== "no" && (
            <IconText icon={CheckOutlined} text={getThirdPartyDeliveryText()} variant="body1" />
          )}
          {deliveryType === "no" && <IconText icon={CloseIcon} text={"Delivery"} variant="body1" />}
        </Grid>
      </Grid>
    </Box>
  );
}
